const initialState = {
	fetchSuspiciousContactsDeletion: null,
	isLoadingSuspiciousContactsDeletionAction: false,
	isConfirmApproveContactsDeletionShown: false,
	isConfirmRejectContactsDeletionShown: false,
	isContactsDeletionConfigLoading: false,
	suspiciousContactsDeletionConfigToSend: null
};

const suspiciousContactsDeletionReducer = ( state = initialState, action ) => {
	switch (action.type) {
		case "FETCH_SUSPICIOUS_CONTACTS_DELETION":
			state = {
				...state,
				fetchSuspiciousContactsDeletion: action.payload
			};
			break;
		case "IS_LOADING_SUSPICIOUS_CONTACTS_DELETION_ACTION":
			state = {
				...state,
				isLoadingSuspiciousContactsDeletionAction: action.payload
			};
			break;
		case "IS_CONFIRM_APPROVE_CONTACTS_DELETION_SHOWN":
			state = {
				...state,
				isConfirmApproveContactsDeletionShown: action.payload
			};
			break;
		case "IS_CONFIRM_REJECT_CONTACTS_DELETION_SHOWN":
			state = {
				...state,
				isConfirmRejectContactsDeletionShown: action.payload
			};
			break;
		case "IS_CONTACTS_DELETION_ENABLED":
			state = {
				...state,
				isContactsDeletionEnabled: action.payload
			};
			break;
		case "IS_CONTACTS_DELETION_CONFIG_LOADING":
			state = {
				...state,
				isContactsDeletionConfigLoading: action.payload
			};
			break;
		case "SUSPICIOUS_CONTACTS_DELETION_CONFIG_TO_SEND":
			state = {
				...state,
				suspiciousContactsDeletionConfigToSend: action.payload
			};
			break;
		default:
			return state;
	}
	return state;
};

export default suspiciousContactsDeletionReducer;
